<template>
    <vue-cookie-accept-decline
            :debug="false"
            :disableDecline="false"
            :showPostponeButton="false"
            @clicked-accept="cookieClickedAccept"
            @clicked-decline="cookieClickedDecline"
            @clicked-postpone="cookieClickedPostpone"
            @removed-cookie="cookieRemovedCookie"
            @status="cookieStatus"
            elementId="myPanel1"
            position="bottom-right"
            ref="myPanel1"
            transitionName="slideFromBottom"
            type="floating"
    >
        <!-- Optional -->
        <template #postponeContent>&times;</template>

        <!-- Optional -->
        <template #message>
            We use cookies to ensure you get the best experience on our website.
            <a href="https://cookiesandyou.com/" target="_blank">Learn More...</a>
        </template>

        <!-- Optional -->
        <template #declineContent>
            <p @click="acceptCookie(false)"> Cancel</p>
        </template>

        <!-- Optional -->
        <template #acceptContent >
            <p @click="acceptCookie(true)"> Got It!</p>
        </template>
    </vue-cookie-accept-decline>
  <!--  <img alt="Vue logo" src="./assets/logo.png">-->
    <HeroSection id="hero"/>
    <BenefitsSection id="benefits" />
    <ProblemSection id="problem" />
    <DetailsSection />
    <DiscoverySection id="discovery" />
    <DeliverySection id="delivery" />
    <FormSection />
    <FooterComponent />
</template>


<script>
import FooterComponent from "@/components/welcome_sections/FooterComponent.vue";
import DiscoverySection from "@/components/welcome_sections/DiscoverySection.vue";
import ProblemSection from "@/components/welcome_sections/ProblemSection.vue";
import FormSection from "@/components/welcome_sections/FormSection.vue";
import BenefitsSection from "@/components/welcome_sections/BenefitsSection.vue";
import DetailsSection from "@/components/welcome_sections/DetailsSection.vue";
import DeliverySection from "@/components/welcome_sections/DeliverySection.vue";
import HeroSection from "@/components/welcome_sections/HeroSection.vue";

import { collection, addDoc } from "firebase/firestore"
// the firestore instance
import db from '/src/firebase/init'
export default {
    name: "HomePage",
    components: {
        HeroSection,
        DeliverySection,
        DetailsSection,
        BenefitsSection,
        FormSection,
        ProblemSection,
        DiscoverySection,
        FooterComponent
    },
    methods: {   async fetchUserIP() {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                return data.ip;
            } catch (error) {
                console.error('Error fetching IP:', error);
                return null;
            }
        },
        async acceptCookie(accepted) {
            // 'users' collection reference
            const colRef = collection(db, 'cookies')
            // data to send
            const dataObj = {
                ip: await this.fetchUserIP() || 'Unknown IP',
                accepted: accepted
            }
            // create document and return reference to it
            const docRef = await addDoc(colRef, dataObj)
            // access auto-generated ID with '.id'
            console.log('Cookie Added with the id:', docRef.id)
        },

    }
}
</script>

<style scoped>

</style>